export default __webpack_public_path__ + "d38e3366616045f8b9ab466b23628a47.gif";